import { useEffect, useState } from "react";
import { Topic } from "roslib";
import { useRos } from "../../services/Ros/utils/rosProvider";
import { subscribe, buildTopicOptions, unsubscribe } from "../../services/Ros/utils/rosTopicCommands";
import { TRANSFORM } from "../../constants/topics";
import { useRobotDetails } from "../../utilities/RobotDetailsContext";


export const useRobotTF = () => {
  const {robotDetails} = useRobotDetails();
  const ROS = useRos();
  const [robotGPS, setRobotGPS] = useState<{ lat: number, long: number } | null>(null);

  useEffect(() => {
    let topic: Topic | undefined;

    const callback = (message: any) => {
        const transforms = message.transforms;
        // console.log(transforms)
        for (const transform of transforms) {
          if (
            transform.child_frame_id === 'base_link' &&
            transform.header.frame_id === 'map'
          ) {
            const { translation,  } = transform.transform;
        
            setRobotGPS({ lat: translation.x, long: translation.y });
          }
          
        }
          

    };
    if (robotDetails.isIndoor){
      topic = subscribe(
        buildTopicOptions(ROS, TRANSFORM.name, TRANSFORM.type, TRANSFORM.throttle),
        callback
      );
    }

    return () => {
      if (topic) {
        unsubscribe(topic);
      }
    };
  }, [ROS]);

  return robotGPS;
};
